import { getStore, collectedOptions } from 'owa-options-store';
import { observer } from 'mobx-react';
import { ActionButton, CommandButton } from 'office-ui-fabric-react/lib/Button';
import { OptionCategory } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { selectCategory } from 'owa-options-orchestration';
import { hideFullOptions } from 'owa-options-core';
import FullOptionSearch from './FullOptionSearch';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { ControlIcons } from 'owa-control-icons';
import openQuickOptions from '../../utils/openQuickOptions';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);
const owaSettingsFlexPaneID = 'OwaSettings';

interface CategoryEntryProps {
    category: OptionCategory;
}

const CategoryEntry = observer((props: CategoryEntryProps) => {
    let buttonStyles = {
        root: className(styles.category, {
            selectedCategory: getStore().currentCategoryKey === props.category.key,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };

    let iconProps = {
        iconName: props.category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };

    return (
        <ActionButton
            styles={buttonStyles}
            key={props.category.key}
            onClick={() => selectCategory(props.category)}
            iconProps={iconProps}
            text={strings[props.category.titleStringKey] as string}
            role="tab"
        />
    );
});

@observer
export default class CategoriesColumn extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.categoriesColumn} role="tablist">
                <span className={styles.title} role="heading" aria-level={2}>
                    {strings.options_title}
                </span>
                <FullOptionSearch />
                <FocusZone direction={FocusZoneDirection.vertical}>
                    {collectedOptions().map(category => (
                        <CategoryEntry category={category} key={category.key} />
                    ))}
                </FocusZone>
                <CommandButton
                    className={styles.viewQuickSettings}
                    onClick={this.goToQuickOptions}
                    iconProps={{
                        iconName: ControlIcons.ChevronLeft,
                        styles: {
                            root: className(styles.icon, 'flipForRtl'),
                        },
                    }}
                    text={strings.optionsFull_goToQuickOptions}
                />
            </div>
        );
    }

    private goToQuickOptions() {
        hideFullOptions(true /* showQuickOptions */);
        openQuickOptions(owaSettingsFlexPaneID);
    }
}
